<app-page-title-bar text="Acerca de nosotros"></app-page-title-bar>

<app-page-container>
  <div
    class="m-t-25"
    ngClass.lt-md="p-25">

    <div
      fxLayout="row"
      fxLayout.lt-md="column">
      <div
        fxFlex="50%"
        class="p-l-25 p-r-25 p-b-25">
        <div class="tuni-box-title-2 text-azul-sunedu font-bold m-t-25 m-b-25">¿Qué es lo que buscamos?</div>
        <div class>
          <h6 class="plomo parrafo max-width-about">
              <strong class="font-bold text-azul-sunedu">TUNI.PE</strong> es una plataforma informática destinada a consolidar y 
              almacenar la información sobre el sistema de educación superior 
              universitaria, la cual es generada por la Superintendencia Nacional de 
              Educación Superior Universitaria en el desarrollo de sus procesos, 
              conforme a las exigencias de la Ley N° 30220, Ley Universitaria y sus 
              modificatorias, y a los lineamientos de la política de aseguramiento de la 
              calidad de la educación superior universitaria.
          </h6>
        </div>
      </div>
      <div
        fxFlex="50%"
        class="padding-box-obj border-azul-sunedu">
        <div>
          <div class="tuni-box-title-2 text-azul-sunedu font-bold m-t-25 m-b-25">¿Qué busca el TUNI.pe?</div>

          <div style="text-align:justify;line-height: 25px;font-size: 15px;">
            <strong class="font-bold text-azul-sunedu">TUNI.PE</strong>
            tiene como objetivo poner a disposición de los ciudadanos 
            toda la información relevante para la toma de decisiones sobre la 
            educación superior universitaria. Además, de facilitar a las 
            universidades, escuelas de posgrado, instituciones y escuelas 
            superiores un medio en línea para la exposición de la información de la 
            educación superior universitaria en forma oportuna y eficiente.
          </div>
        </div>

      </div>
    </div>

    <div class="tuni-box-title-2 text-azul-sunedu font-bold m-25">Objetivos Específicos</div>
    <mat-divider
      class="m-r-25 m-l-25"
      fxHide.xs></mat-divider>
    <div fxLayout="row wrap">
      <div
        ngClass.xs="m-t-10 m-b-10"
        ngClass.gt-xs="p-25"
        fxFlex.gt-sm="33.3%"
        fxFlex.sm="50%">
        <mat-card class="card-about">
          <img
            alt="image"
            class="about-image"
            src="assets/svg/icons/iconos_peru_estudia_1.svg">
          <div class>
            <h6 class="parrafo">
                <strong class="text-azul-sunedu">Constituir una fuente de información oficial sobre el sistema de educación superior universitaria</strong> accesible para los miembros de la comunidad universitaria,
                los ciudadanos y la misma institución, con el resguardo de la confidencialidad pertinente.
              </h6>
          </div>
        </mat-card>
      </div>

      <div
        ngClass.xs="m-t-10 m-b-10"
        ngClass.gt-xs="p-25"
        fxFlex.gt-sm="33.3%"
        fxFlex.sm="50%">
        <mat-card class="card-about">
          <img
            alt="image"
            class="about-image"
            src="assets/svg/icons/iconos_peru_estudia_4.svg">
          <div class>
            <h6 class="parrafo">
                <strong class="text-azul-sunedu">Promover el interés de los ciudadanos en la gestión</strong> y desempeño de las universidades, escuelas de posgrado, instituciones y escuelas de educación superior,
                para su participación directa.
              </h6>
          </div>
        </mat-card>
      </div>

      <div
        ngClass.xs="m-t-10 m-b-10"
        ngClass.gt-xs="p-25"
        fxFlex.gt-sm="33.3%"
        fxFlex.sm="50%">
        <mat-card class="card-about">
          <img
            alt="image"
            class="about-image"
            src="assets/svg/icons/iconos_peru_estudia_5.svg">
          <div class>
            <h6 class="parrafo">
                <strong class="text-azul-sunedu">Garantizar la transparencia de la gestión</strong> y desempeño de las universidades, escuelas de posgrado, instituciones y escuelas de educación superior, sobre las condiciones básicas de calidad.
              </h6>
          </div>
        </mat-card>
      </div>

    </div>
  </div>

  <div class="tuni-box-title-2 bg-azul-sunedu font-bold p-l-25 p-r-25 p-t-10 p-b-10 m-t-25 m-b-25">Glosario informativo</div>

  <div class="text-azul-sunedu tuni-box-title-2 font-bold m-r-25 m-l-25">Comunidad Universitaria</div>

  <div
    fxLayout="row"
    fxLayout.lt-md="column">

    <div fxFlex="70%">

      <div class>
        <!-- <div class="font-bold m-t-15 tuni-box-title-1">
          <ul>
            <li>Comunidad estudiantil</li>
          </ul>
        </div> -->

        <div
          fxLayout="row wrap"
          fxLayout.xs="column">
          <div
            ngClass.xs="p-15"
            ngClass.gt-xs="p-t-15 p-r-15"
            fxFlex="50%">
            <mat-card
              class="card-informacion p-25"
              fxLayout="row">
              <div
                fxFlex="30%"
                fxLayoutAlign="flex-start top"
                fxHide.xs>
                <span class="tuni-icono-xl2 tuni-icono-informativa-postulante"></span>
              </div>
              <div fxFlex="70%">
                <div class="font-bold tuni-box-title-1">Postulante</div>
                <div class="parrafo-card m-t-10">
                  Persona que aspira ingresar a una institución superior universitaria a través de alguna modalidad de admisión vigente en la institución educativa.
                </div>
              </div>
            </mat-card>
          </div>
          <div
            ngClass.xs="p-15"
            ngClass.gt-xs="p-t-15 p-r-15"
            fxFlex="50%">
            <mat-card class="card-informacion p-25">
              <div
                fxFlex="30%"
                fxLayoutAlign="flex-start top"
                fxHide.xs>
                <span class="tuni-icono-xl2 tuni-icono-informativa-ingresante"></span>
              </div>
              <div fxFlex="70%">
                <div class="font-bold tuni-box-title-1">Ingresante</div>
                <div class="parrafo-card m-t-10">
                  Aquella persona que cumplió con los requisitos establecidos para su admisión a un programa de una institución de educación superior universitaria.
                </div>
              </div>
            </mat-card>
          </div>
          <div
            ngClass.xs="p-15"
            ngClass.gt-xs="p-t-15 p-r-15"
            fxFlex="50%">
            <mat-card class="card-informacion p-25">
              <div
                fxFlex="30%"
                fxLayoutAlign="flex-start top"
                fxHide.xs>
                <span class="tuni-icono-xl2 tuni-icono-informativa-matriculado"></span>
              </div>
              <div fxFlex="70%">
                <div class="font-bold tuni-box-title-1">Matriculado</div>
                <div class="parrafo-card m-t-10">
                  Aquella persona que, luego de haber aprobado el nivel de educación secundaria, cumplió con los requisitos establecidos para su admisión en la institución de educación superior universitaria y se matriculó en un periodo académico.
                </div>
              </div>
            </mat-card>
          </div>
          <!-- <div
            ngClass.xs="p-15"
            ngClass.gt-xs="p-t-15 p-r-15"
            fxFlex="50%">
            <mat-card class="card-informacion p-25">
              <div
                fxFlex="30%"
                fxLayoutAlign="flex-start center"
                fxHide.xs>
                <span class="tuni-icono-xl2 tuni-icono-informativa-egresado"></span>
              </div>
              <div fxFlex="70%">
                <div class="font-bold tuni-box-title-1">Egresado</div>
                <div class="parrafo-card">
                  Es el estudiante que ha completado todas las asignaturas del plan de estudios de su especialidad y cumple con los requisitos expuestos en el reglamento de Grados y Títulos de la universidad para obtener un grado académico universitario.
                </div>
              </div>
            </mat-card>
          </div> -->
          <div
            ngClass.xs="p-15"
            ngClass.gt-xs="p-t-15 p-r-15"
            fxFlex="50%">
            <mat-card class="card-informacion p-25">
              <div
                fxFlex="30%"
                fxLayoutAlign="flex-start top"
                fxHide.xs>
                <span class="tuni-icono-xl2 tuni-icono-informativa-docente"></span>
              </div>
              <div fxFlex="70%">
                <div class="font-bold tuni-box-title-1">Docente</div>
                <div class="parrafo-card m-t-10">
                  Aquella persona dedicada a la 
                  enseñanza e investigación en los 
                  programas de estudio de los niveles de 
                  pregrado y posgrado. A su vez, el 
                  docente universitario tiene como 
                  funciones el mejoramiento continuo y 
                  permanente de la enseñanza, la 
                  proyección social y la gestión 
                  universitaria.
                </div>
              </div>
            </mat-card>
          </div>
        </div>
      </div>

      <!-- <div class="m-t-25">
        <div class="font-bold m-t-15 m-b-15 tuni-box-title-1">
          <ul>
            <li>Docente</li>
          </ul>
        </div>
        <div ngClass.xs="p-15">
          <mat-card ngClass.gt-xs="p-25 m-r-15">
            <div
              fxFlex="15%"
              fxHide.xs>
              <span class="tuni-icono-xl2 tuni-icono-informativa-docente"></span>
            </div>
            <div fxFlex="85%">
              <div class="font-bold tuni-box-title-1">Docente</div>
              <div class="parrafo-card">
                Aquella persona dedicada a la enseñanza e investigación en los programas de estudio de los niveles de pregrado y posgrado. A su vez, el docente universitario tiene como funciones el mejoramiento continuo y permanente de la enseñanza, la proyección social y la gestión universitaria.
              </div>
            </div>
          </mat-card>
        </div>

      </div> -->

    </div>

    <div
      fxFlex="30%"
      fxHide.lt-md>

      <img
        class="img-comunidad m-t-15"
        src="/assets/img/web/DSC_8272.png">

      <img
        class="img-comunidad"
        src="/assets/img/web/8M2A0025.png">

    </div>

  </div>

  <div class="text-azul-sunedu tuni-box-title-2 font-bold m-r-25 m-l-25">Institucional</div>

  <div
    fxLayout="row"
    fxLayout.lt-md="column">

    <div fxFlex="70%">

      <div class>

        <div
          fxLayout="row wrap"
          fxLayout.xs="column">
          <div
            ngClass.xs="p-15"
            ngClass.gt-xs="p-t-15 p-r-15"
            fxFlex="50%">
            <mat-card
              class="card-informacion p-25"
              fxLayout="row">
              <div
                fxFlex="30%"
                fxLayoutAlign="flex-start top"
                fxHide.xs>
                <span class="tuni-icono-xl2 tuni-icono-informativa-filial"></span>
              </div>
              <div fxFlex="70%">
                <div class="font-bold tuni-box-title-1">Filial</div>
                <div class="parrafo-card m-t-10">
                  Refiere a la sede desconcentrada de la 
                  universidad, constituida fuera del ámbito 
                  provincial de la sede universitaria, 
                  destinada a la prestación del servicio 
                  educativo superior y al cumplimiento de 
                  los fines previstos en la Ley 
                  Universitaria.
                </div>
              </div>
            </mat-card>
          </div>
          <div
            ngClass.xs="p-15"
            ngClass.gt-xs="p-t-15 p-r-15"
            fxFlex="50%">
            <mat-card class="card-informacion p-25">
              <div
                fxFlex="30%"
                fxLayoutAlign="flex-start top"
                fxHide.xs>
                <span class="tuni-icono-xl2 tuni-icono-informativa-local-educativo"></span>
              </div>
              <div fxFlex="70%">
                <div class="font-bold tuni-box-title-1">Local educativo (Campus)</div>
                <div class="parrafo-card m-t-10">
                  Es el espacio físico destinado a la 
                  prestación del servicio educativo 
                  superior universitario y al cumplimiento 
                  de los fines previstos en la Ley 
                  Universitaria, conformado por el 
                  conjunto de terrenos y edificios.
                </div>
              </div>
            </mat-card>
          </div>
          <div
            ngClass.xs="p-15"
            ngClass.gt-xs="p-t-15 p-r-15"
            fxFlex="50%">
            <mat-card class="card-informacion p-25">
              <div
                fxFlex="30%"
                fxLayoutAlign="flex-start top"
                fxHide.xs>
                <span class="tuni-icono-xl2 tuni-icono-informativa-sede-universitaria"></span>
              </div>
              <div fxFlex="70%">
                <div class="font-bold tuni-box-title-1">Sede universitaria</div>
                <div class="parrafo-card m-t-10">
                  Refiere a un establecimiento 
                  universitario autorizado mediante la 
                  licencia otorgada por la SUNEDU, 
                  constituido en el ámbito provincial en el 
                  que se encuentra su domicilio, conforme 
                  figura en el instrumento legal de su 
                  creación, destinado a la provisión del 
                  servicio educativo superior universitario 
                  y al cumplimiento de los fines previstos 
                  en la Ley Universitaria.
                </div>
              </div>
            </mat-card>
          </div>

          <div
            ngClass.xs="p-15"
            ngClass.gt-xs="p-t-15 p-r-15"
            fxFlex="50%">
            <mat-card class="card-informacion p-25">
              <div
                fxFlex="30%"
                fxLayoutAlign="flex-start top"
                fxHide.xs>
                <span class="tuni-icono-xl2 tuni-icono-informativa-universidad"></span>
              </div>
              <div fxFlex="70%">
                <div class="font-bold tuni-box-title-1">Universidad</div>
                <div class="parrafo-card m-t-10">
                  Corresponde a una comunidad 
                  académica conformada por docentes, 
                  estudiantes y graduados, orientada a la 
                  investigación, docencia, y proyección 
                  social, que brinda una formación 
                  humanista, científica y tecnológica con 
                  una clara conciencia de nuestro país 
                  como realidad multicultural.
                </div>
              </div>
            </mat-card>
          </div>
        </div>
      </div>
    </div>

    <div
      fxFlex="30%"
      fxHide.lt-md>

      <img
        class="img-comunidad m-t-15"
        src="/assets/img/web/Recurso-15@3x.png">

      <img
        class="img-comunidad"
        src="/assets/img/web/Recurso-16@3x.png">

    </div>

  </div>

  <!-- <div class="tuni-box-title-2 bg-azul-sunedu font-bold p-l-25 p-r-25 p-t-10 p-b-10 m-t-25
  m-b-25">Videos informativos</div>

  <div>
    <div class="text-azul-sunedu tuni-box-title-2 font-bold m-r-25 m-l-25">Hablemos de TUNI.pe</div>
  </div>

  <div>
    <div class="text-azul-sunedu tuni-box-title-2 font-bold m-r-25 m-l-25">Encuentra tu uni con TUNI.pe</div>
  </div> -->
</app-page-container>

<app-section-footer></app-section-footer>
